EMMY.reports = {
    init: function () {
        EMMY.reports.numEntriesRedirect();
        var inputWidth = $('.orders-table').width();

        $('select').select2({
            placeholder: '',
            dropdownPosition: 'below',
        });

        $('.choices-filter-group select').each(function () {
            var selectLabel = $(this).closest('.choices-filter-group').find('h4').text();
            $(this).closest('.choices-filter-group').find('.dropdown-wrapper').text(selectLabel);

            var filterGrouping = 'filter-tags-' + $(this).attr('id');
            var that = $(this);
            EMMY.reports._setOptionasButton(that, filterGrouping);
            $(this).on('change', function (e) {
                var that2 = $(this);
                EMMY.reports._setOptionasButton(that, filterGrouping);

                // Auto submit select if class exists
                if($(this).hasClass('autosubmit-select')) {
                    $(this).closest('form').submit();
                }
            });
            $('body').on('click', '.name2', function (e) {
                var valueSelected = this.getAttribute('data-filter');
                EMMY.reports._removeItem(that, valueSelected);
                $(this).remove();
            });
        });
    },
    _setOptionasButton: function(that, filterGrouping) {
        var optionSelected = that.find("option:selected");
        $('.search-filters-added .' + filterGrouping).html('');
        for (var i = 0; i < optionSelected.length; i++) {
            var valueSelected = optionSelected[i].value;
            var textSelected = optionSelected[i].text;
            console.log(valueSelected, '-----', textSelected)
            if ((valueSelected != undefined) && (valueSelected != '')) {
                var div = document.createElement('span');
                div.innerText = textSelected;
                div.className = 'name2';
                div.setAttribute('data-filter', valueSelected);
                var searchText = document.querySelector('.search-filters-added .' + filterGrouping);
                searchText.appendChild(div);
            }
        }
    },
    _removeItem: function(selectList, idToRemove) {
        var values = selectList.val();
        if (values) {
            var i = values.indexOf(idToRemove);
            if (i >= 0) {
                values.splice(i, 1);
                if(values.length != 0) {
                    selectList.val(values).change();
                } else {
                    selectList.val('').change();
                }
            }
        }
    },
    numEntriesRedirect: function() {
        $('.num-entries-select').on('change', function(e) {
            window.location = $(this).val();
        });
    },
}
